import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'unique' })
export class UniquePipe implements PipeTransform {
	/**
	 * Filter an array of items, removing duplicates using a key to compare.
	 * @param value - The array of items.
	 * @param key - The key to compare by.
	 * @returns The filtered array of unique items.
	 */
	transform<T extends Record<string, any>>(value: T[], key: keyof T): T[] {
		if (!Array.isArray(value)) {
			throw new Error('The input value must be an array');
		}

		const dict = value.reduce<Record<string | number, T>>((prev, curr) => {
			if (curr[key] === undefined) {
				throw new Error(`Key '${String(key)}' does not exist in item`);
			}
			prev[curr[key]] = curr;
			return prev;
		}, {});

		return Object.values(dict);
	}
}
